import { create } from 'zustand';
import { createInitialState } from '../shared';

import { store as CandidateStore } from '../../../../../apps/web/src/state/use-candidates/store';

export enum ViewMode {
  VIEW = 'view-mode',
  SELECT = 'select-mode',
}

export enum SelectionMode {
  SELECT_ALL = 'select-all',
  DESELECT_ALL = 'deselect-all',
}

export const initialState = {
  ...createInitialState([]),
  selectedIds: [],
  viewMode: ViewMode.VIEW,
  selectionMode: SelectionMode.DESELECT_ALL,
};

export interface CandidateSelectionState {
  viewMode: ViewMode;
  selectedIds: string[];
  selectionMode: SelectionMode;
  selectId: (candidateId: string) => void;
  selectAll: () => void;
  deselectAll: () => void;
  toggleViewMode: () => void;
  toggleSelectAll: () => void;
  unSelectId: (candidateId: string) => void;
}

export const store = create<CandidateSelectionState>((set, store) => ({
  selectedIds: initialState.selectedIds,
  selectionMode: initialState.selectionMode,
  viewMode: initialState.viewMode,
  selectId: (candidateId: string) => {
    set((state: CandidateSelectionState) => ({
      ...state,
      selectedIds: Array.from(new Set([...state.selectedIds, candidateId])),
    }));
  },
  unSelectId: (candidateID: string) => {
    set((state: CandidateSelectionState) => ({
      ...state,
      selectedIds: state.selectedIds.filter((id) => id !== candidateID),
    }));
  },
  selectAll: () => {
    set({
      selectedIds: CandidateStore.getState()._ids,
      selectionMode: SelectionMode.SELECT_ALL,
    });
  },
  deselectAll: () => {
    set({
      selectedIds: [],
      selectionMode: SelectionMode.DESELECT_ALL,
    });
  },
  toggleSelectAll: () => {
    if (store().selectionMode === SelectionMode.SELECT_ALL) {
      store().deselectAll();
    } else {
      store().selectAll();
    }
  },
  toggleViewMode: () => {
    store().deselectAll();
    if (store().viewMode === ViewMode.VIEW) {
      set({
        viewMode: ViewMode.SELECT,
      });
    } else {
      set({
        viewMode: ViewMode.VIEW,
      });
    }
  },
}));
